export const TipoDocumentoLegajo = Object.freeze({
    CARPETA: "CARPETA",
    DOCUMENTO: "DOCUMENTO",
});